import { Component } from "react";
import { Link } from "react-router-dom";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="bg-ink min-h-screen flex items-center" data-testid="error-boundary-fallback">
        <div className="max-w-2xl mx-auto px-6 py-24 text-center">
          <img
            src={`${process.env.REACT_APP_BACKEND_URL}/api/uploads/logo_primary.png`}
            alt="Dirty Church Chronicles"
            className="h-16 w-auto mx-auto mb-10 opacity-90"
            data-testid="error-boundary-logo"
          />
          <p className="text-crimsonhi uppercase tracking-[0.35em] text-xs mb-4">Signal Interrupted</p>
          <h1 className="font-display font-black uppercase text-paper text-4xl sm:text-6xl tracking-tight mb-6">
            The transmission broke.
          </h1>
          <p className="text-paperdim/70 text-base mb-10 leading-relaxed">
            Something unexpected interrupted this page. Your chronicles are safe — this is a
            temporary rendering fault, not lost work. Try reloading, or return home.
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <button
              onClick={this.handleRetry}
              className="bg-crimson hover:bg-crimsonhi text-paper uppercase tracking-[0.2em] text-xs px-8 py-4 rounded-full transition-colors"
              data-testid="error-boundary-retry-btn"
            >
              Reload the page
            </button>
            <Link
              to="/"
              className="border border-paper/25 hover:border-paper/60 text-paper uppercase tracking-[0.2em] text-xs px-8 py-4 rounded-full transition-colors"
              data-testid="error-boundary-home-link"
            >
              Return home
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
